import { render, staticRenderFns } from "./ShiftForm.vue?vue&type=template&id=b1c0814a&scoped=true"
import script from "./ShiftForm.vue?vue&type=script&lang=js"
export * from "./ShiftForm.vue?vue&type=script&lang=js"
import style0 from "./ShiftForm.vue?vue&type=style&index=0&id=b1c0814a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c0814a",
  null
  
)

export default component.exports